import React, { lazy } from "react";
import { Route } from "react-router";
import routeURL from "./routeConstants";

const RunsList = lazy(() => import("../pages/RunsList"));
const RunDetail = lazy(() => import("../pages/RunDetail"));

// Only two pages, unlike migration-validation's three: client_summary has no
// external report to diff against, so there's no per-transaction drill-down
// level — a run's entire result is its counters plus a bounded findings list.
//
// Access is restricted server-side only (International Office / Country Office),
// via BaseController::checkVisibilityRestriction() in
// ClientSummaryValidationController::beforeAction(). No route-level guard here
// by design — the API is the security boundary.
const clientSummaryValidationRoutes = (
  <>
    <Route path={routeURL.RUNS} component={RunsList} />
    <Route path={routeURL.RUN_DETAIL} component={RunDetail} />
  </>
);

export default clientSummaryValidationRoutes;
